import { ASSET_PREFIX } from 'utils/constants';
import styles from './DrawDetails.module.css';

interface IDrawDetailsProps {
    details: string;
}

const DrawDetails = ({details}: IDrawDetailsProps) => {

    return (
        <div className={styles.drawDetailContainer}>
            <img src={`${ASSET_PREFIX}/images/token-town/info-icon.svg`}></img>
            <p>{details}</p>
        </div>
    );
}

export default DrawDetails;